import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, CardBody, CardFooter, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import { base_api_url } from '../../../config';
import { toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

const NewPassword = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [email, setEmail] = useState('')
  const [key, setKey] = useState('')
  const [status, setStatus] = useState(0)

  const [message, setMessage] = useState('')

  const register = () => {

    if (confirmPassword === password) {

      try {
        axios.post(`${base_api_url}Auth/ResetPassword/` + key, {
          email: email,
          password: password,
        })
          .then(function (response) {
            console.log(response);
            setMessage(response.data.Message)
            setStatus(1);
            redirect()
          })
          .catch(function (error) {
            console.log(error);
            setStatus(2)
          });
      } catch (error) {
      }
    }
  }

  const redirect = () => {
    setTimeout(() => {
      setStatus(10)
    }, 4000)
  }


  useEffect(() => {
    const queryString = window.location.href;
    const user = getAllUrlParams(queryString)
    setEmail(user.email)
    setKey(user.key)
  }, [])

  function getAllUrlParams(url) {

    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {

      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split('#')[0];

      // split our query string into its component parts
      var arr = queryString.split('&');

      for (var i = 0; i < arr.length; i++) {
        // separate the keys and the values
        var a = arr[i].split('=');

        // set parameter name and value (use 'true' if empty)
        var paramName = a[0];
        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

        // (optional) keep case consistent
        paramName = paramName.toLowerCase();
        if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

        // if the paramName ends with square brackets, e.g. colors[] or colors[2]
        if (paramName.match(/\[(\d+)?\]$/)) {

          // create key if it doesn't exist
          var key = paramName.replace(/\[(\d+)?\]/, '');
          if (!obj[key]) obj[key] = [];

          // if it's an indexed array e.g. colors[2]
          if (paramName.match(/\[\d+\]$/)) {
            // get the index value and add the entry at the appropriate position
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            // otherwise add the value to the end of the array
            obj[key].push(paramValue);
          }
        } else {
          // we're dealing with a string
          if (!obj[paramName]) {
            // if it doesn't exist, create property
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string') {
            // if property does exist and it's a string, convert it to an array
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            // otherwise add the property
            obj[paramName].push(paramValue);
          }
        }
      }
    }

    return obj;
  }


  return (
    <div className="app flex-row align-items-center">
      <Container>
        {status === 10 ? <Redirect from="#/register" to="/login" /> : null}


        <Row className="justify-content-center">
          <Col md="6">
            {status === 1 ? <Alert color="success">
              {message}
            </Alert> : null}
            {status === 2 ? <Alert color="warning">
              Invalid
            </Alert> : null}
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="6">
            <Card className="mx-4">
              <CardBody className="p-4">
                <h1>Create new password</h1>
                <p className="text-muted">Your new password must be different
                  from previous used passwords.</p>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="icon-lock"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input type="password" placeholder="New Password" onChange={(e) => setPassword(e.target.value)} />
                </InputGroup>
                <InputGroup className="mb-4">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="icon-lock"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input type="password" placeholder="Confirm New Password" onChange={(e) => setConfirmPassword(e.target.value)} />
                </InputGroup>
                <Button color="success" block onClick={() => register(email, username, password)}>Reset Password</Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NewPassword;


// WEBPACK FOOTER //
// ./src/views/Pages/Register/NewPassword.js